/* eslint-disable no-nested-ternary */
import React, { useState, useContext } from "react";
import styled, { ThemeContext } from "styled-components";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { Menu } from "../../types/Menu";
import { Box } from "../Box";
import { NavAccordionGroup } from "../NavAccordionGroup";
import { MobileMenuItems } from "../MobileMenuItems";
import { MobileMenuHeader } from "./_/MobileMenuHeader";
import { SecondaryMobileHeader } from "../SecondaryHeader/_/SecondaryMobileHeader/SecondaryMobileHeader";
import { Flex } from "../Flex";
import { Link } from "../Link";
import { VectorLogo } from "../VectorLogo";
import { Image } from "../Image";
import { SearchBox } from "../SearchBox";
import { Icon } from "../Icon";
import { Text } from "../Text";
import Exit from "../../assets/images/exit.svg";

export interface MobileMenuProps {
  showActionBar?: boolean;
  show: boolean;
  currentPath: string;
  onClose: () => void;
  serviceCatalogueNav?: boolean;
  myProfile?: boolean;
}

/* istanbul ignore next */
export const Overlay = styled(Box)<MobileMenuProps>`
  height: 100%;
  width: 0%;
  position: fixed;
  //make sure the Overlay is on top of all
  z-index: 100;
  top: 0;
  left: 0;
  overflow-x: hidden;
  ${props => props.show && "width: 100%"}
`;

const OverlayContent = styled(Box)`
  position: relative;
  width: 100%;
  height: 100%;
`;
const StyledSearchBox = styled(SearchBox)`
  width: 100%;
  background-color: #000840;
  border: 0;
  outline: none;
  font-size: 16px;
  text-overflow: ellipsis;
`;
const StyledSubmitButton = styled.input`
  display: none;
`;
const StyledForm = styled.form`
  display: inherit;
  width: inherit;
`;
export const StyledClearBox = styled(Box)`
  cursor: pointer;
`;

export const MobileMenu: React.FC<MobileMenuProps & Menu> = ({
  show,
  currentPath,
  menu,
  onClose,
  showActionBar,
  serviceCatalogueNav,
  myProfile,
}) => {
  const theme = useContext(ThemeContext);
  const { white } = theme.colors;
  const [value, setValue] = useState("");
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };
  const handleClear = () => setValue("");
  const handleSubmit = (e: any) => {
    e.preventDefault();
    window.location.replace(
      `https://www.vector.co.nz/special-pages/search?searchtext=${value}&searchmode=anyword`,
    );
  };

  return (
    <Overlay show={show} bg="primary">
      {myProfile ? (
        <Flex
          mt={["16px", "16px", "16px", "16px", "27px"]}
          pl={["10px", "10px", "10px", "10px", "31px"]}
          pr="10px"
          justifyContent="space-between"
        >
          <Flex>
            <SecondaryMobileHeader serviceCatalogueNav />
            <Link href="https://www.vector.co.nz">
              <VectorLogo />
            </Link>
          </Flex>
          <Box mr="11px" mt="4px" onClick={onClose}>
            <Image src={Exit} alt="exit" />
          </Box>
        </Flex>
      ) : (
        <>
          <MobileMenuHeader
            onClose={onClose}
            showActionBar={
              myProfile || serviceCatalogueNav ? false : showActionBar
            }
            serviceCatalogueNav
          />
        </>
      )}
      <Box>
        <OverlayContent>
          {serviceCatalogueNav ? (
            !myProfile ? (
              <>
                <Flex justifyContent="space-between" height="51px">
                  <Flex width="93%">
                    <Link
                      href={`https://www.vector.co.nz/special-pages/search?searchtext=${value}&searchmode=anyword`}
                    >
                      <Icon
                        icon={faSearch}
                        fontSize={4}
                        color={white}
                        px={2}
                        py={3}
                      />
                    </Link>
                    <StyledForm action="." onSubmit={handleSubmit}>
                      <StyledSearchBox
                        placeholder="Enter a topic e.g. outages, tree trimming..."
                        value={value}
                        color={white}
                        onChange={onChange}
                        type="text"
                        data-testid="seachbox"
                      />
                      <StyledSubmitButton id="search" type="submit" />
                    </StyledForm>
                  </Flex>
                  {value ? (
                    <StyledClearBox onClick={handleClear} pr={2}>
                      <Text fontSize={0} color="white">
                        Clear
                      </Text>
                    </StyledClearBox>
                  ) : null}
                </Flex>
                <NavAccordionGroup menu={menu} />
              </>
            ) : (
              <NavAccordionGroup
                data-testid="navaccordiongroup"
                menu={menu}
                myProfile={myProfile}
              />
            )
          ) : (
            <MobileMenuItems
              items={menu}
              currentPath={currentPath}
              onItemClick={onClose}
            />
          )}
        </OverlayContent>
      </Box>
    </Overlay>
  );
};

MobileMenu.defaultProps = {
  serviceCatalogueNav: false,
  myProfile: false,
};
